module.exports = __webpack_public_path__ + "static/img/book16.67bbc30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book16.jpg
// module id = EDYr
// module chunks = 1